import { useState, useEffect } from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Button, ModalBody, ModalHeader, FormFeedback } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { Modal } from '../../common-components'
import { setProcessingSuccess, startStandardSelling, setCloneAppId, getEIPPolicyDetails } from '../actions'
import { setNotificationMessage } from 'quick-quote/notification/actions'
import { getToggles } from 'quick-quote/feature-toggles'
import { toPolicyDisplay } from 'core/service/retrieve-customer/policy-list'
import { getEnableRetrieveCustomerPolicy } from 'quick-quote/selectors'
import { detectPolicyRoleParties } from 'e-submission/sagas/form'
import { analytics } from 'analytics/analytics'

const dataPromiseDataBeneficiary = import(/* webpackChunkName: "e-submission-data" */ 'e-submission/mocks')

const ConfirmSelectedButton = (props) => {
  const { selectedAppId, setIsConfirmSelected, onGetPolicyDetails } = props
  const isDisabled = _.isEmpty(selectedAppId) || _.isEmpty(selectedAppId.appId)
  const css = !isDisabled ? 'primary' : 'btn btn-disabled'
  return (
    <div style={{ textAlign: 'center' }}>
      <Button
        color={css}
        className={css}
        disabled={isDisabled}
        onClick={() => {
          onGetPolicyDetails()
        }}
      >
        ยืนยัน
      </Button>
    </div>
  )
}

const StyledButton = styled(Button)`
  width: 100px;
  margin: 0 8px;
`

const ConfirmCloneAppButton = (props) => {
  const {
    onExit,
    selectedAppId,
    setIsConfirmSelected,
    setNotificationMessage,
    setDataSelectedPolicy,
    onGetPolicyDetails,
    onCloneAppId,
  } = props
  return (
    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
      <StyledButton
        color={'outline-primary'}
        className={'outline-primary'}
        onClick={() => {
          setIsConfirmSelected(false)
          setDataSelectedPolicy(null)
        }}
      >
        กลับ
      </StyledButton>
      <StyledButton
        color={'primary'}
        className={'primary'}
        onClick={() => {
          onCloneAppId(selectedAppId)
          onExit()
          analytics.sendGGAEvent('CLONE_APP', 'CONFIRM_SELECTED_APP', {
            selected_app_id: selectedAppId,
          })
          setNotificationMessage({ type: 'RemoteSellingVc' })
        }}
      >
        ยืนยัน
      </StyledButton>
    </div>
  )
}

const DialogModalHeader = (props) => {
  const { onExit, setProcessingSuccess, isConfirmSelected } = props
  return (
    <ModalHeader
      toggle={() => {
        setProcessingSuccess()
        onExit()
      }}
    >
      {isConfirmSelected ? 'ยืนยันการคัดลอกข้อมูล' : 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก'}
    </ModalHeader>
  )
}

const StyledContainer = styled.div`
  background-color: ${({ theme }) => theme.variables['$color-wild-sand']};
  padding: 0.5rem 0.8rem;
  border-radius: 0.5rem;
  margin: 8px 0;

  &.selected {
    background-color: white;
    border: 2.5px solid ${({ theme }) => theme.variables['$brand-primary']};
  }

  &.confirmed {
    background-color: ${({ theme }) => theme.variables['$brand-primary']};
    color: white;
  }

  p {
    margin-bottom: 0;
    font-size: 0.95rem;
  }
`

const PolicyDetailContainer = (props) => {
  const { isSelected, onClick, policyNo, productName, insuredName, insuredLastname } = props
  const className = isSelected ? 'selected' : ''

  return (
    <StyledContainer className={className} onClick={onClick}>
      <p>
        เลขที่กรมธรรม์: <b>{policyNo}</b>
      </p>
      <p>
        แบบประกัน: <b>{productName}</b>
      </p>
      <p>
        ชื่อ: <b>{insuredName}</b>
      </p>
      <p>
        นามสกุล: <b>{insuredLastname}</b>
      </p>
    </StyledContainer>
  )
}

const ConfirmPolicyDetailContainer = (props) => {
  const { insuredName, insuredLastname, payer, beneficiary = [], isSelectedApplication } = props

  const beneficiaryList = beneficiary
    .map((bene) => {
      const { firstName, lastName } = bene

      return `${firstName || ''} ${lastName || ''}`.trim()
    })
    .filter((name) => !_.isEmpty(name))
    .join(', ')

  let textBeneficiary = ''
  if (!_.isEmpty(payer) && isSelectedApplication) {
    if (beneficiaryList) {
      textBeneficiary = `${payer}, ${beneficiaryList}`
    } else {
      textBeneficiary = payer
    }
  } else {
    textBeneficiary = beneficiaryList
  }

  return (
    <StyledContainer className="confirmed">
      <p>
        ชื่อ: <b>{insuredName}</b>
      </p>
      <p>
        นามสกุล: <b>{insuredLastname}</b>
      </p>
      <p>
        ผู้ชำระเบี้ย: <b>{payer || '-'}</b>
      </p>
      <p>
        ผู้รับผลประโยชน์: <b>{textBeneficiary || '-'}</b>
      </p>
    </StyledContainer>
  )
}

const DialogBody = (props) => {
  const {
    appLists,
    policyLists,
    selectedAppId,
    setSelectedAppId,
    isConfirmSelected,
    isSelectedApplication,
    setIsSelectedApplication,
    dataSelectedPolicy,
    setDataSelectedPolicy,
    enableRetrieveCustomerPolicy,
  } = props

  const enablePolicyTab = enableRetrieveCustomerPolicy
  const dataList = isSelectedApplication || !enablePolicyTab ? appLists : policyLists
  const notFoundData = _.isEmpty(dataList)
  const shownData = isConfirmSelected ? dataList.filter((item) => item.appId === selectedAppId) : dataList

  return (
    <div className="form-group">
      {isConfirmSelected == false && (!_.isEmpty(appLists) || !_.isEmpty(policyLists)) ? (
        <div style={{ marginBottom: '20px' }}>
          <Button
            className={`clone-app tab-selete-policy ${isSelectedApplication ? 'selected' : ''}`}
            onClick={() => {
              if (!isSelectedApplication) {
                setIsSelectedApplication(true)
                setSelectedAppId({})
              }
            }}
          >
            {'ใบคำขอ'}
          </Button>
          {enablePolicyTab && (
            <Button
              className={`clone-app tab-selete-policy ${!isSelectedApplication ? 'selected' : ''}`}
              onClick={() => {
                if (isSelectedApplication) {
                  setIsSelectedApplication(false)
                  setSelectedAppId({})
                }
              }}
            >
              {'กรมธรรม์'}
            </Button>
          )}
        </div>
      ) : (
        <></>
      )}
      {notFoundData ? (
        <div style={{ textAlign: 'center' }}>
          <span>ระบบตรวจสอบไม่พบข้อมูล</span>
          <p>กรุณาปิดหน้านี้เพื่อดำเนินการใบคำขอ</p>
        </div>
      ) : (
        <div className="card-list">
          {isConfirmSelected == false ? (
            shownData.map((resPolicy) => {
              const { appId, policyNo, productName, insuredName, insuredLastname, payer, beneficiary } = resPolicy
              const isSelected = appId === selectedAppId?.appId

              return (
                <PolicyDetailContainer
                  key={appId}
                  isSelected={isSelected}
                  isConfirmSelected={isConfirmSelected}
                  onClick={() => {
                    const payloadSelectApp = { appId, type: isSelectedApplication ? 'application' : 'policy' }
                    console.log('payloadSelectApp', payloadSelectApp)
                    setSelectedAppId(payloadSelectApp)
                    setDataSelectedPolicy(resPolicy)
                  }}
                  policyNo={policyNo}
                  productName={productName}
                  insuredName={insuredName}
                  insuredLastname={insuredLastname}
                />
              )
            })
          ) : (
            <>
              <ConfirmPolicyDetailContainer
                key={`policy-detail-confirm${dataSelectedPolicy?.appId}`}
                isConfirmSelected={isConfirmSelected}
                insuredName={dataSelectedPolicy?.insuredName}
                insuredLastname={dataSelectedPolicy?.insuredLastname}
                payer={dataSelectedPolicy?.payer}
                beneficiary={dataSelectedPolicy?.beneficiary}
                isSelectedApplication={isSelectedApplication}
              />
              <FormFeedback className="info-message attached-icon" style={{ marginTop: '1rem' }}>
                <p>หมายเหตุ: เงื่อนไขการคัดลอกข้อมูลขึ้นอยู่กับกรมธรรม์และใบคำขอ</p>
              </FormFeedback>
            </>
          )}
        </div>
      )}
    </div>
  )
}

const CustomModal = styled(Modal)`
  .modal-title {
    flex: 1 0 auto;
    font-weight: bold;
    font-size: 1rem;
    color: ${({ theme }) => theme.variables['$brand-primary']};
    max-width: 80%;
    padding-left: 0.5rem;
  }
  .modal-body {
    padding: 15px 25px;
  }
  .form-group {
    margin-bottom: 1.5rem;
    margin-top: 0.5rem;
    .btn {
      margin-bottom: 0.25rem;
    }
  }
  .form-control-feedback {
    margin-top: 0.5rem;
  }
  &.fit-viewport {
    .modal-content {
      display: flex;
      flex-direction: column;
      max-height: calc(85vh - 1.75rem);
    }
    .modal-body {
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
    .form-group {
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
    .card-list {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      min-height: 0;
    }
  }
`

const _SearchAppListPopup = (props) => {
  const [selectedAppId, setSelectedAppId] = useState({})
  const [isConfirmSelected, setIsConfirmSelected] = useState(false)
  const { notificationMessage, onExit, appLists, policyLists, GETEIPPolicyDetails, clonedPolicy, callingApi } = props
  const popupProps = {
    ...props,
    selectedAppId,
    setSelectedAppId,
    isConfirmSelected,
    setIsConfirmSelected,
  }
  const notFoundData = _.isEmpty(appLists) && _.isEmpty(policyLists)
  const [isSelectedApplication, setIsSelectedApplication] = useState(true)
  const [dataSelectedPolicy, setDataSelectedPolicy] = useState(null)
  const [isWaitingPolicyDetails, setIsWaitingPolicyDetails] = useState(false)
  const [mockBeneficiaryList, setMockBeneficiaryList] = useState([])
  const beneficiaryListSource = mockBeneficiaryList

  const mapPolicyDetailsToSelectedPolicy = (policyDetails) => {
    if (!policyDetails) return null

    const relationshipTextByValue = (beneficiaryListSource || []).reduce((acc, item) => {
      if (item?.value) {
        acc[item.value] = item.text
      }
      return acc
    }, {})

    const mappedBeneficiary = (policyDetails.beneficiary || []).map((bene) => {
      const relationValue = bene?.relations?.value || bene?.relationship || bene?.beneficiaryRelationship || ''
      return {
        ...bene,
        firstName: bene?.firstName || bene?.beneficiaryFirstName || '',
        lastName: bene?.lastName || bene?.beneficiaryLastName || '',
        relations: bene?.relations || {
          value: relationValue,
          text: relationshipTextByValue[relationValue] || relationValue,
        },
      }
    })
    console.log('mappedBeneficiary', mappedBeneficiary)

    const detectedRoleParties = detectPolicyRoleParties(policyDetails)
    console.log('detectedRoleParties', detectedRoleParties)
    const payerName = detectedRoleParties.payer
      ? _.get(detectedRoleParties, 'payer.firstName', '') + ' ' + _.get(detectedRoleParties, 'payer.lastName', '')
      : null
    return {
      ...policyDetails,
      insuredName: detectedRoleParties.insured.firstName,
      insuredLastname: detectedRoleParties.insured.lastName,
      payer: payerName,
      beneficiary: mappedBeneficiary,
    }
  }

  useEffect(() => {
    let isMounted = true
    if (_.isEmpty(appLists)) {
      setIsSelectedApplication(false)
    }
    if (_.isEmpty(policyLists) && _.isEmpty(appLists)) {
      setIsSelectedApplication(true)
    }

    dataPromiseDataBeneficiary
      .then((module) => {
        if (isMounted) {
          setMockBeneficiaryList(module.beneficiary || [])
        }
      })
      .catch((error) => {
        console.error('Error loading beneficiary mock data:', error)
      })

    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (!isWaitingPolicyDetails || callingApi) {
      return
    }

    if (clonedPolicy) {
      const mappedPolicyDetails = mapPolicyDetailsToSelectedPolicy(clonedPolicy)
      setDataSelectedPolicy((prev) => ({ ...prev, ...mappedPolicyDetails }))
      setIsConfirmSelected(true)
    }

    setIsWaitingPolicyDetails(false)
  }, [callingApi, clonedPolicy, isWaitingPolicyDetails, setIsConfirmSelected, beneficiaryListSource])

  const onGetPolicyDetails = async () => {
    try {
      if (isSelectedApplication) {
        setIsConfirmSelected(true)
        return
      }
      const payload = {
        policyNo: dataSelectedPolicy.policyNo,
        policyEffectiveDate: dataSelectedPolicy.policyEffectiveDate,
        policyExpirationDate: dataSelectedPolicy.policyEffectiveToDate,
      }
      setIsWaitingPolicyDetails(true)
      GETEIPPolicyDetails(payload)
    } catch (error) {
      setIsWaitingPolicyDetails(false)
      console.error('Error fetching policy details:', error)
    }
  }

  return (
    <CustomModal
      isOpen={notificationMessage !== 'None'}
      backdrop={true}
      size="lg"
      className={isConfirmSelected ? '' : 'fit-viewport'}
      modalClassName="default-bootstrap"
      toggle={() => {
        props.setProcessingSuccess()
        onExit()
      }}
    >
      <DialogModalHeader {...popupProps} onExit={() => onExit()} />
      <ModalBody>
        <DialogBody
          {...popupProps}
          isSelectedApplication={isSelectedApplication}
          setIsSelectedApplication={setIsSelectedApplication}
          dataSelectedPolicy={dataSelectedPolicy}
          setDataSelectedPolicy={setDataSelectedPolicy}
        />
        {notFoundData ? null : isConfirmSelected ? (
          <ConfirmCloneAppButton
            {...popupProps}
            setDataSelectedPolicy={setDataSelectedPolicy}
            onGetPolicyDetails={onGetPolicyDetails}
            onExit={() => onExit()}
          />
        ) : (
          <ConfirmSelectedButton {...popupProps} onGetPolicyDetails={onGetPolicyDetails} onExit={() => onExit()} />
        )}
      </ModalBody>
    </CustomModal>
  )
}

const mapStateToProps = (state) => {
  const cloneAppList = _.get(state, 'cloneAppList')
  const appLists = cloneAppList.applicationList.map((_app) => {
    const { _id, policyId, quickQuote, insured, payer, beneficiary } = _app

    return {
      appId: _id,
      policyNo: policyId,
      productName: _.get(quickQuote, 'selectedDisplayProduct.basicPlanName', ''),
      insuredName: _.get(insured, 'firstName', ''),
      insuredLastname: _.get(insured, 'lastName', ''),
      payer,
      beneficiary,
    }
  })
  const policyLists = cloneAppList.policyList.map(toPolicyDisplay)
  return {
    appLists,
    policyLists,
    clonedPolicy: _.get(state, 'clonedPolicy'),
    callingApi: _.get(state, 'cloneAppSearchStatus') === 'searching',
    enableRetrieveCustomerPolicy: getEnableRetrieveCustomerPolicy(state),
  }
}

const mapDispatchToProps = (dispatch) => ({
  setProcessingSuccess: bindActionCreators(setProcessingSuccess, dispatch),
  setNotificationMessage: bindActionCreators(setNotificationMessage, dispatch),
  onCloneAppId: bindActionCreators(setCloneAppId, dispatch),
  startStandardSelling: bindActionCreators(startStandardSelling, dispatch),
  GETEIPPolicyDetails: bindActionCreators(getEIPPolicyDetails, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(_SearchAppListPopup)
